import {FunctionComponent, ReactElement} from "react";
import { Navigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import useUserStore from "../store/userStore";


export function withCondition(
    Component: FunctionComponent,
    condition: boolean,
    redirectTo: string
) {
    return function InnerComponent(props: any) {
        return condition ? <Component {...props} /> : <Navigate to={redirectTo} replace />
    }
}

/** A more specific variation */
export const withLoggedIn = (Component: React.FunctionComponent) =>
    withCondition(Component, useUserStore.getState().token ? true : false, '/')